import { createClient } from '@supabase/supabase-js'
import { getSupabaseConfig } from '@/lib/config/env'
import { createSupabaseFetch } from '@/lib/supabase/fetch'
// import type { Database } from './database.types'

// Timeouts, time budget and GET-only retries: see lib/supabase/fetch.ts.
const supabaseFetch = createSupabaseFetch()

export function createAdminClient() {
  const { url: supabaseUrl, serviceRoleKey } = getSupabaseConfig()

  if (!supabaseUrl || !serviceRoleKey) {
    throw new Error(
      'Supabase admin client cannot be created: URL or service role key is missing. ' +
        'Check your environment configuration.'
    )
  }

  return createClient(supabaseUrl, serviceRoleKey, {
    auth: {
      autoRefreshToken: false,
      persistSession: false,
    },
    global: {
      fetch: supabaseFetch,
    },
  })
}
